import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

// Inicia o Stimulus
const application = Application.start()

// Carrega controllers automaticamente (Rails 7+)
// Se estiver usando importmap, certifique-se que está configurado
import "./controllers"

console.log("🚀 Application started")

// Debug: verifica se controllers estão registrados
window.addEventListener("turbo:load", () => {
    console.log("✅ Turbo loaded, controllers:", application.controllers)
})

 